






import { Vue, Component, Prop } from 'vue-property-decorator';
import { Sankey, ISankeyNode, ISankeyLink } from './Sankey';
import VueD3 from '../VueD3.vue';

@Component({
  components: {
    VueD3,
  },
})
export default class ChartWrapper extends Vue {
  @Prop() readonly width: number | undefined;
  @Prop() readonly height: number | undefined;
  @Prop() readonly exportTitle: string | undefined;
  @Prop() readonly exportFileName: string | undefined;
  @Prop({ default: false }) readonly showExport!: boolean;
  @Prop({ required: true }) readonly nodes!: ISankeyNode[];
  @Prop({ required: true }) readonly links!: ISankeyLink[];

  vinstance: Sankey | null = null;

  mounted() {
    this.draw();
  }

  draw() {
    this.vinstance = new Sankey({
      target: this.$refs['vis-ref'],
      nodes: this.nodes,
      links: this.links,
      exportFileName: this.exportFileName,
      exportTitle: this.exportTitle,
      width: this.width,
      height: this.height,
    });
    this.$emit('init', this.vinstance);
  }

  handleExportPng() {
    if (this.vinstance) {
      this.vinstance.exportToPng();
    }
  }
}
